import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { safeGet, safeSet } from "@/lib/safeStorage";

const ThemeCtx = createContext(null);
const STORAGE_KEY = "bakery_theme"; // non-sensitive user preference

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => safeGet(STORAGE_KEY) || "light");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    safeSet(STORAGE_KEY, theme);
  }, [theme]);

  const value = useMemo(
    () => ({
      theme,
      toggle: () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    }),
    [theme]
  );
  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
